import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};

export const Eyebrow = ({ children, className = "" }) => (
  <span
    data-testid="section-eyebrow"
    className={`font-body text-[11px] font-bold uppercase tracking-[0.22em] text-[#9A958C] flex items-center gap-2.5 ${className}`}
  >
    <span className="h-px w-7 bg-[#F8B808]" />
    {children}
  </span>
);

export const SectionHeading = ({ eyebrow, title, subtitle, align = "center" }) => {
  const center = align === "center";
  return (
    <div
      className={`flex flex-col max-w-3xl ${
        center ? "items-start text-left lg:items-center lg:text-center lg:mx-auto" : "items-start text-left"
      }`}
    >
      <h2 className="font-heading text-[31px] sm:text-5xl lg:text-[45px] font-medium tracking-tight text-[#1A1A1A] leading-[1.04]">
        {title}
      </h2>
      {subtitle && (
        <p className="font-body text-lg md:text-xl text-[#6B6B66] mt-6 leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  );
};
